import { render } from "./VxList.vue?vue&type=template&id=64c81f6c"
import script from "./VxList.vue?vue&type=script&lang=js"
export * from "./VxList.vue?vue&type=script&lang=js"

import "./VxList.vue?vue&type=style&index=0&id=64c81f6c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__